import React from 'react'
import { motion } from 'framer-motion'
import dummy from '../../Assets/Images/dummy.jpg.webp'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
const AccountDetails = ()=>{
    const userDetails = useSelector((state)=>state.auth.userDetails)
    const {t} = useTranslation()
    return (
        <motion.div className='flex flex-row w-full h-full'>
            {
                userDetails.firstName ? <motion.div className="w-full h-full flex flex-col gap-2 bg-white rounded-lg shadow-lg p-5">
                <img src={userDetails?.previewUrls.length > 0 ? userDetails?.previewUrls[0]?.imageUrl : dummy} alt="Profile" className="w-44 h-44  object-contain mb-2" />
                <motion.div className='flex flex-row items-center w-full'>
                    <p className='text-sm'>{t('Name')}</p>:&nbsp;
                    <p className='text-sm font-bold'>{userDetails.firstName}</p>
                </motion.div>
                 <motion.div className='flex flex-row items-center w-full'>
                    <p className='text-sm'>{t('Mobile')}</p>:&nbsp;
                    <p className='text-sm font-bold'>{userDetails.contactInformation.mobileNumber}</p>
                </motion.div>
                <motion.div className='flex flex-row items-center w-full'>
                    <p className='text-sm'>{t('Reference Id')}</p>:&nbsp;
                    <p className='text-sm font-bold'>{userDetails.refId}</p>
                </motion.div>
            </motion.div> : "Loading please wait..."
            }
        </motion.div>
    )
}

export default AccountDetails